// extracted by mini-css-extract-plugin
export var layout = "layout-module--layout--27d29";
export var main = "layout-module--main--4a21e";
export var mobileHeader = "layout-module--mobile-header--9145d";
export var webHeader = "layout-module--web-header--44872";